import { InspectionId, JournalId } from 'types';

export const INSPECTIONS = (journalId: JournalId) => `/api/v1/journals/${journalId}/inspections`;
export const INSPECTION = (journalId: JournalId, inspectionId: InspectionId) =>
    `/api/v1/journals/${journalId}/inspections/${inspectionId}`;
